import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { TaskStep, PrimaryData } from 'app-models';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ToastrService } from 'ngx-toastr';
import { getStepDetails, updateStepStatusToInitialState, updateStepStatus } from 'visa-store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { StepStatusUpdatePayloadService } from 'step-status-update-payload-service';
import { VisaExtendedState } from '../../utility/interfaces/visa-extended-state';
import { NgForm } from '@angular/forms';
import { DirtyFormGuard } from 'dirty-check-store';
import { first } from 'rxjs/internal/operators/first';
import { AppServicesLibraryService } from 'app-services-library';
import { AwaitLotteryService } from '../await-lottery-selection/await-lottery-selection.service';
import { AwaitLotterySelectionComponent } from '../await-lottery-selection/await-lottery-selection.component';
import { LcaJobDetailsPositionComponent } from '../lca-job-details-position/lca-job-details-position.component';
import { SelectingLcaSocLibraryComponent } from 'selecting-lca-soc-library';
import { LcaSocCodeLibraryComponent } from 'lca-soc-code-library';
import { LcaJobDetailsWorkComponent } from '../lca-job-details-work/lca-job-details-work.component';
import { SyncDetailsService } from '../../utility/services/sync-details.service';
import { CustomErrorToastComponent } from 'custom-error-toast';

@Component({
  selector: 'app-lca-and-job-details',
  templateUrl: './lca-and-job-details.component.html',
  styleUrls: ['./lca-and-job-details.component.scss']
})
export class LcaAndJobDetailsComponent implements OnInit {

  @ViewChild('awaitLotteryForm', { static: true }) awaitLotteryForm: NgForm;
  stepDetails: TaskStep;
  observableSubscription$ = new Subject();
  inputData: PrimaryData;
  guardSubscription: any;
  dynamicInjector: Injector;
  responseNote: string;
  typeOfButton: string;
  activeTabIndex = null;
  accordianHeader = [
  { header: "H-1B Lottery Selection Details", component: AwaitLotterySelectionComponent },
  { header: "Position Details", component: LcaJobDetailsPositionComponent },
  { header: "Identify Work Location", component: LcaJobDetailsWorkComponent },
  { header: "Select SOC Code & Assign LCA", component: LcaSocCodeLibraryComponent },
  { header: "Link LCA to the Petition", component: SelectingLcaSocLibraryComponent }
]
  isBeneficiaryNotify: boolean;
  isPetitionCap: boolean;
  skipList: any;
  disabledControls = false;
  jobPositionTitle: any;
  infoMsg: string;
  showNext: boolean = false;
  showPrev: boolean = false;
  constructor(
    private store: Store<VisaExtendedState>,
    public dynamicDialogRef: DynamicDialogRef,
    public dynamicDialogConfig: DynamicDialogConfig,
    private guard: DirtyFormGuard,
    private stepStatusUpdatePayloadCostruction: StepStatusUpdatePayloadService,
    private injector: Injector,
    private appServicesLibraryService: AppServicesLibraryService,
    private syncDetailsService: SyncDetailsService,
    private toastr: ToastrService,
  ) {
    this.infoMsg = 'Note that some of the steps are interdependent. Such steps will also be skipped when you skip the parent step.';
    this.inputData = this.dynamicDialogConfig.data;
    this.isBeneficiaryNotify = false;
    this.showNext = this.inputData?.showNext; 
    this.showPrev = this.inputData?.showPrev;
  } 

  ngOnInit(): void {
    this.onLoadSkip();
    if(sessionStorage.getItem('simplifyType')&&sessionStorage.getItem('simplifyType')=='CAP'){
      this.isPetitionCap = true;
    } else {
      this.isPetitionCap = false;
    }
    console.log('this.inputData app-await-lottery-selection', this.inputData);
    console.log('this.inputData isViewMode app-await-lottery-selection app-await-lottery-selection', this.inputData['isViewMode']);
    console.log('this.inputData isCaseRequest app-await-lottery-selection', this.inputData['isCaseRequest']);
    // Get Specific step details by passing step code
    this.store.pipe(select(getStepDetails, { id: this.dynamicDialogConfig.data.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data: TaskStep) => {
      this.stepDetails = data;
      this.responseNote = this.stepDetails.stepResponseNote ? this.stepDetails.stepResponseNote : null;
      this.isBeneficiaryNotify = this.stepDetails.isBeneficiaryNotify === 1 ? true : false;
      this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
      this.toggleControlsStatus();
    });
    this.dynamicInjector = Injector.create({
      providers: [
        { provide: 'simplifiedH1b', useValue: true },
        { provide: 'primaryData', useValue: this.dynamicDialogConfig.data }
      ],
      parent: this.injector
    });
  }

  // getStatusype() {
  //   this.apiService.getStatusAndResponse('AWAITLOT').subscribe((response: ImagilityBaseResponse) => {
  //     this.statusTypeList = response['response'];
  //   });
  // }

  toggleControlsStatus() {
    this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
  }

  onLoadSkip(){
    const palyload: any = this.inputData;
    this.syncDetailsService.getSkipStepDetails(palyload.individualStepId,sessionStorage.getItem('customStepTaskId')).subscribe((res)=>{
      if(res){
        this.skipList = res;
        this.infoMessage(this.skipList);
      }
    });
  }

  infoMessage(skipList){
    this.skipList = skipList;
    this.skipList.map((data: any) => {
      let childStepInfo = '';
      let stepInfo = '';
      if (data.child.length === 1) {
          childStepInfo = data.child[0];
          stepInfo = 'step';
      } else if (data.child.length > 1) {
          stepInfo = 'steps';
          childStepInfo = data.child.slice(0, -1).join(', ') + ' and ' + data.child[data.child.length - 1];
      }
  
      data.infoMsg = `When you skip ${data.stepName} (Parent step), ${childStepInfo} (child ${stepInfo}) will automatically be skipped.`;
      
      return data;
    });
  }

  ngOnDestroy() {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    // Update the Step Status state to empty state
    this.store.dispatch(updateStepStatusToInitialState());
  }

  handleClose() {
    this.guardSubscription = this.guard.canDeactivate().pipe(first()).subscribe((response: boolean) => {
      if (response) {
        this.dynamicDialogRef.close();
      }
      else {
        return false;
      }
    });
  }

  updateStepStatus(status) {
    this.store.dispatch(updateStepStatus({
      payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(
        this.stepDetails, status, this.responseNote, this.isBeneficiaryNotify),
      subTaskId: this.stepDetails.taskId,
      stepId: this.dynamicDialogConfig.data.stepId,
      visaType: this.inputData.caseType === 'I130' ?
        this.inputData.caseType : this.inputData.visatype
    }));
  }

  handleSwitchChange(event, item){
    if(event && item){
      this.syncDetailsService.saveSkipStepDetails(item.taskStepId, event.checked).subscribe((res)=>{
        if(res.status == 200){
          this.skipList = res.data;
          this.infoMessage(this.skipList);
          this.toastr.success(res.message, 'Success');
        } else {
          CustomErrorToastComponent.showErrorToast(this.toastr, res.message);
        }
      });
    }
  }

  onClickAccordion(item){
    this.activeTabIndex = item;
  }
  jobSubmitted(event){
    if(event){
      this.jobPositionTitle = event;
    }
  }

}
